export enum RpcMethods {
    GET_TOKEN_METHOD = 'csrf.getToken',
    PRODCAT_METHOD = 'prodcat',
    TRANS_GET_RPC_METHOD = 'trans.get',
    UPDATE_BAG_RPC_METHOD = 'rpc.form'
}
